function setLocationPointArea(point, area) {
  return point && { ...point, area };
}

export default setLocationPointArea;
